// extracted by mini-css-extract-plugin
export default {"preferredPaymentMethodSwitch":"PreferredPaymentMethodSwitch_preferredPaymentMethodSwitch__El8Uj","saveError":"PreferredPaymentMethodSwitch_saveError__cr0FG"};